// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1SQqL","title":"ClientInsurance_title__1zk00","itemText":"ClientInsurance_itemText__jHJEt"};